import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=578fc888&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=js&"
export * from "./SearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=578fc888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fc888",
  null
  
)

export default component.exports